var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"c-input",class:_vm.cls,attrs:{"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.Update($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }